import subaccsService from "@/api/subaccsService";

export const SELF_HOSTED_SCRIPT_STATUS_EVENT = "self-hosted-script:status";

// Fetches the status after a change of what is baked into the script and broadcasts it,
// so an open self-hosted script block updates itself.
export const refreshSelfHostedStatus = async (vm, platformId) => {
  const res = await subaccsService.getSelfHostedScriptStatus(platformId);
  const status = res && res.status === 200 ? res.data : null;

  if (status) {
    vm.$root.$emit(SELF_HOSTED_SCRIPT_STATUS_EVENT, { platformId, status });
  }

  return status;
};

// Shows the "saved" alert after platform settings are saved and, when the user hosts a
// downloaded copy of the script, reminds them that the copy has to be downloaded again.
export const showSavedAlert = async (vm, platformId, { title, text = "" } = {}) => {
  const status = await refreshSelfHostedStatus(vm, platformId);

  if (status && status.downloaded && status.settings_outdated) {
    const reminder = vm.$t(
      status.auto_sync_active ? "platform.self_hosted.settings_saved_auto_sync" : "platform.self_hosted.settings_saved_download_again"
    );
    vm.$alert({
      type: "success",
      title,
      text: text ? `${text} ${reminder}` : reminder,
      time: 6000,
    });
    return;
  }

  vm.$alert({ type: "success", title, text });
};

export const showSettingsSavedAlert = (vm, platformId) => showSavedAlert(vm, platformId, { title: vm.$t("save_successfully") });
